import { Inject, Injectable } from '@angular/core';
import { ApiService, API_SERVICE } from 'ng-upgrade-api';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppUserService {

  constructor(@Inject(API_SERVICE) private apiService: ApiService) {
  }

  LoginForWechat(model: any): Observable<any> {
    return this.apiService.postJson(`RepUser/LoginByEnterpriseWechat`, {
      body: model
    });
  }

  LoginForApp(model: any): Observable<any> {
    // @ts-ignore
    return this.apiService.postJson(`RepUser/LoginByPassword`, {
      body: model
    });
  }

  LoginForLdapApp(model: any): Observable<any> {
    // @ts-ignore
    return this.apiService.postJson(`RepUser/LoginByLDAP`, {
      body: model
    });
  }

  // 获取矢量和密钥
  getSecretAndIv(): Observable<any> {
    return this.apiService.getJson(`System/GetAesKey`);
  }

  Logout(): Observable<any> {
    if (environment.isApp) {
      // @ts-ignore
      return this.apiService.getJson(`RepUser/LogoutByPassword`);
    }
    return this.apiService.getJson(`RepUser/LogoutByEnterpriseWechat`);
  }

  /*
  * 选择岗位
  * */
  SwitchTerritery(territoryId: string): Observable<any> {
    // @ts-ignore
    return this.apiService.postJson(`RepUser/SwitchTerritery`, {
      body: { territoryId }
    });
  }

  GetWechatIsWeChatLogin(): Observable<any> {
    return this.apiService.getJson(`System/GetWechatIsWeChatLogin`);
  }


  /*
* Vconsole
* */
  Vconsole(): Observable<any> {
    return this.apiService.getJson(`System/GetVconsoleInfo`);
  }

  ChangeStaffPassword(model: any): Observable<any> {
    return this.apiService.postJson(`RepStaff/ChangeStaffPassword`, {
      body: model
    });
  }

  GetIsEnableLogin(): Observable<any> {
    return this.apiService.getJson(`Wow/GetIsEnableLogin`);
  }

  GetFirstLoginConsentArticle(model: any): Observable<any> {
    return this.apiService.postJson(`user/GetFirstLoginConsentArticle`, {
      body: model
    });
  }

  SaveUserAgreeRecord(model: any): Observable<any> {
    return this.apiService.postJson(`user/SaveUserAgreeRecord`, {
      body: model
    });
  }

  GetUserLastMoblie(): Observable<any> {
    return this.apiService.getJson(`Category/GetUserLastMoblie`);
  }


  SendCategoryCode(): Observable<any> {
    return this.apiService.getJson(`Category/SendCategoryCode`);
  }

  GetStaffQrEmail(): Observable<any> {
    return this.apiService.getJson(`Wow/GetStaffQrEmail`);
  }

  GetWeChatAgentId(): Observable<any> {
    return this.apiService.getJson(`System/GetWeChatAgentId`);
  }


  //获取知情同意书
  GetActiveInformedConsent(model: any): Observable<any> {
    return this.apiService.postJson(`InformedConsent/GetActiveInformedConsent`, {
      body: model
    });
  }

  // 保存知情同意书
  SaveUserAgreeRecordPost(model: any): Observable<any> {
    return this.apiService.postJson(`InformedConsent/SaveUserAgreeRecord`, {
      body: model
    });
  }

  // 获取rsa公钥
  getRSAPubKey(): Observable<any> {
    return this.apiService.getJson(`System/GetRSAPubKey`);
  }

  GetMapConfig(): Observable<any> {
    return this.apiService.getJson(`System/GetMapConfig`);
  }


}
